import { render, staticRenderFns } from "./NewProvider.vue?vue&type=template&id=67d13b15&scoped=true"
import script from "./NewProvider.vue?vue&type=script&lang=js"
export * from "./NewProvider.vue?vue&type=script&lang=js"
import style0 from "./NewProvider.vue?vue&type=style&index=0&id=67d13b15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d13b15",
  null
  
)

export default component.exports